export const enum CardTypes {
  Default = 'default',
  Offer = 'offer'
}
